// extracted by mini-css-extract-plugin
export default {"editPlateAppearanceButton":"ScorekeepingTable_editPlateAppearanceButton__mg3aq","scorekeepingTable":"ScorekeepingTable_scorekeepingTable__Qrzae"};